import routerOptions0 from "/Users/amin/Documents/Work/HHAA/Projects/game/taline-shell-game/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}